// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"tl-z","hideOnMobile":"ul-z"};